import reduceReducers from "reduce-reducers";
import {
  EDIT_USER_SUCCESS,
  LOAD_USERS_FAILURE,
} from "redux-store/users/actions";
import { auth } from "store/auth";

import {
  AUTH_GET_TOKEN_FAILURE,
  AUTH_TOKEN_CHANGE,
  USER_LOGIN,
  USER_LOGOUT,
} from "./actions";

const initialState = {
  sessionExpired: null,
  statusCode: null,
  user: null,
  token: auth.getToken(),
};

function usersReducer(state, users) {
  const user = users.find((u) => u.current_user) || null;

  return {
    ...state,
    user,
  };
}

function _userEditReducer(state, user) {
  if (state.user && state.user.id === user.id) {
    return {
      ...state,
      user,
    };
  }

  return state;
}

function userEditReducer(state = {}, action) {
  const { type, payload = {} } = action;
  const { data: user } = payload;

  switch (type) {
    case EDIT_USER_SUCCESS: {
      return {
        ..._userEditReducer(state, user),
      };
    }
    default:
      return state;
  }
}

function _authReducer(state = initialState, action) {
  const { type, payload = {} } = action;
  const { response, sessionExpired, statusCode, user } = payload;

  switch (type) {
    case AUTH_GET_TOKEN_FAILURE:
      return {
        ...state,
        sessionExpired: false,
        statusCode: response.status,
        user: null,
      };
    case LOAD_USERS_FAILURE:
      // When app inits, it can fail to call the api. For example
      // 502 gateway error. We need to show that the app is loaded
      // via statusCode.
      return {
        ...state,
        statusCode: response.status,
      };
    case USER_LOGIN:
      return {
        ...state,
        user,
        sessionExpired: false,
        statusCode: response.status,
      };
    case USER_LOGOUT: {
      // If we manually trigger this action, there will be no response.
      // You must send statusCode for USER_LOGOUT. Typically you will
      // send 401 indicating login required.
      // ---
      // Do not override currently expired session.
      // Multiple user logout actions could otherwise erase the
      // sessionExpired state. This should only be overridden by a successful
      // user login action.

      return {
        ...state,
        sessionExpired: state.sessionExpired ? true : Boolean(sessionExpired),
        statusCode,
        user: null,
      };
    }
    default:
      return state;
  }
}

function tokenReducer(state = {}, action) {
  const { type, payload = {} } = action;
  const { token } = payload;

  switch (type) {
    case AUTH_TOKEN_CHANGE:
      return {
        ...state,
        token,
      };
    default:
      return state;
  }
}

const authReducer = reduceReducers(_authReducer, userEditReducer, tokenReducer);

export {
  _authReducer,
  _userEditReducer,
  authReducer,
  initialState,
  userEditReducer,
  usersReducer,
};
